module.exports = __webpack_public_path__ + "static/media/bottom_banner_9_2.51e24e34.png";